<template>
  <div class="app">
    <flash-message />
    <HeaderBar />
    <main class="main">
      <router-view/>
    </main>
    <FooterBar />
  </div>
</template>

<script>

  import HeaderBar from '@/components/header-bar'
  import FooterBar from '@/components/footer-bar'

  export default {

    components: {
      HeaderBar,
      FooterBar,
    }

  }

</script>

<style lang="css" src="vue-flash-message/dist/vue-flash-message.min.css">

</style>

<style lang="scss">

  @import "assets/scss/palette";

  @import "assets/scss/branding";

  @import "assets/scss/icons";

  .app {
    margin: 1rem 5%;
  }


  .no-webp body {
    background-image: url("./assets/road_bg.jpg");
  }

  .webp body{
    background-image: url("./assets/road_bg.webp");
  }

  body {
    margin: 0;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: top center;
    background-attachment: fixed;
    background-color: #67a2b2;
    font-family: 'Verdana', sans-serif;
    font-size: 18px;

  }

  a {
    color: white;
    transition: color ease-in-out 0.3s;

    &:hover {
      color: $orange;
    }
  }

  p, ul, li, h1, h2, h3, h4 {
    margin: 0;
    padding: 0;
  }

  iframe, img {
    display: block;
  }

  img {
    display: block;
  }

  .flash__message {
    position: fixed;
    top: 2rem;
    right: 2rem;
  }

  @media (max-width: 1000px) {
    body {
      background-image: url("./assets/road_bg_skinny.jpg") !important;
      font-size: 20px;
    }
  }

  @media (max-width: 700px) {
    body {
      background-image: url("./assets/road_bg_very_skinny.jpg") !important;
      font-size: 22px;
    }
  }

</style>
